// extracted by mini-css-extract-plugin
export default {"wrapper":"d49Np","qr":"cRxcV","title":"YNf3V"};